import React, { PureComponent } from "react";
import Notification from "./Containers/NotificationContainer";

class NotificationPage extends PureComponent {
  render() {
    return (
      <div>
        <Notification
          ruleTeamId={this.props.match.params.id}
          searchParams={this.props.location.search}
        />
      </div>
    );
  }
}

export default NotificationPage;
